import { render, staticRenderFns } from "./Viagens.vue?vue&type=template&id=37681fbe&scoped=true"
import script from "./Viagens.vue?vue&type=script&lang=js"
export * from "./Viagens.vue?vue&type=script&lang=js"
import style0 from "./Viagens.vue?vue&type=style&index=0&id=37681fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37681fbe",
  null
  
)

export default component.exports